export interface Actividad {
  idActividad: number;
  codigo: string;
  descripcion: string;
  nombreCorto: string | null;
  codigoAlterno: string | null;
  esActividadRendimiento: boolean;
  esRendimientoLineaProduccion: boolean;
  activo: boolean;
  labores?: Labor[];
  costos?: CostoActividad[];
}

export interface Labor {
  idLabor: number;
  idActividad: number;
  codigo: string;
  descripcion: string;
  unidadMedida: string;
  costoHora: number;
  factor: number;
  avanceSt: number;
  medidaRendimiento: string | null;
  ventaHora: number;
  activo: boolean;
  actividad?: Actividad;
}

export interface CostoActividad {
  idCostoActividad: number;
  idActividad: number;
  idLabor: number;
  periodo: string;
  cantidad: number;
  unidadMedida: string;
  descripcionUM: string | null;
  costo: number;
  tipoBono: string | null;
  actividad?: Actividad;
  labor?: Labor;
}

export interface Consumidor {
  idConsumidor: number;
  codigo: string;
  descripcion: string;
  activo: boolean;
}

export interface GrupoTrabajo {
  idGrupoTrabajo: number;
  codigo: string;
  descripcion: string;
  activo: boolean;
}

export interface AsistenciaRendimiento {
  idAsistenciaRendimiento: number;
  idPeriodo: number;
  fecha: string;
  idResponsable: number | null;
  idTurno: number | null;
  idGrupoTrabajo: number | null;
  estado: string;
  observaciones: string | null;
  cantidadTrabajadores: number;
  totalRendimiento: number;
  promedioRendimiento: number;
  fechaCreacion: string;
  periodo?: { idPeriodo: number; anio: number; mes: number };
  responsable?: { idTrabajador: number; personal?: { personaContacto?: string } };
  turno?: { idTurno: number; descripcion: string };
  grupoTrabajo?: { idGrupoTrabajo: number; descripcion: string };
  detalles?: AsistenciaRendimientoDetalle[];
}

export interface AsistenciaRendimientoDetalle {
  idDetalle: number;
  idAsistenciaRendimiento: number;
  idTrabajador: number;
  idActividad: number;
  idLabor: number;
  item: number;
  tipoAsistencia: string;
  rendimientoSoles: number;
  cantidadTotal: number;
  observaciones: string | null;
  trabajador?: { idTrabajador: number; personal?: { personaContacto?: string } };
  actividad?: Actividad;
  labor?: Labor;
  producciones?: AsistenciaRendimientoProduccion[];
}

export interface AsistenciaRendimientoProduccion {
  idProduccion: number;
  idDetalle: number;
  idConsumidor: number;
  cantidad: number;
  consumidor?: Consumidor;
}

export interface GrupoTrabajadorResumen {
  idGrupoTrabajador: number;
  idGrupoTrabajo: number;
  idTrabajador: number;
  nombreTrabajador: string;
  identificacion: string;
  activo: boolean;
}

export interface RendimientoResumen {
  idPeriodo: number;
  totalDocumentos: number;
  totalTrabajadores: number;
  totalRendimiento: number;
  promedioRendimiento: number;
}

export interface SaveRendimientoRequest {
  idAsistenciaRendimiento: number;
  idPeriodo: number;
  fecha: string;
  idResponsable: number | null;
  idTurno: number | null;
  idGrupoTrabajo: number | null;
  observaciones: string | null;
  detalles: SaveRendimientoDetalle[];
}

export interface SaveRendimientoDetalle {
  idDetalle: number;
  idTrabajador: number;
  idActividad: number;
  idLabor: number;
  item: number;
  tipoAsistencia: string;
  rendimientoSoles: number;
  cantidadTotal: number;
  observaciones: string | null;
  producciones: SaveProduccion[];
}

export interface SaveProduccion {
  idProduccion: number;
  idConsumidor: number;
  cantidad: number;
}

export const ESTADOS_RENDIMIENTO = [
  { value: 'PENDIENTE', label: 'Pendiente', color: '#ed6c02' },
  { value: 'PROCESADO', label: 'Procesado', color: '#2e7d32' },
  { value: 'ANULADO', label: 'Anulado', color: '#d32f2f' },
];

export const TIPOS_ASISTENCIA_REND = [
  { value: 'R', label: 'Rendimiento' },
  { value: 'A', label: 'Asistencia' },
];
